import { TimePeriodSegmentedVizViews } from '../types';
import { timePeriodSegmentedBarChartViewConfig } from './bar-chart/view-config';
import { timePeriodSegmentedTableViewViewConfig } from './table-view/view-config';

export const timePeriodSegmentedViewConfigs = [
  {
    name: TimePeriodSegmentedVizViews.BAR_CHART,
    viewConfig: timePeriodSegmentedBarChartViewConfig,
  },
  {
    name: TimePeriodSegmentedVizViews.TABLE_VIEW,
    viewConfig: timePeriodSegmentedTableViewViewConfig,
  },
];
